import { textStyleCss } from 'src/theme/atlas';
import styled from 'styled-components';

export type TooltipVariant = 'up' | 'down' | 'left' | 'right';

export const TooltipFrame = styled.div<{
  variant: TooltipVariant;
  width?: string;
  removePadding?: boolean;
  maxWidth?: string;
  extraPaddingForRoot?: number;
  lineBreak?: 'anywhere' | 'normal';
}>`
  padding: ${(props) =>
    props.removePadding
      ? '0'
      : `${props.theme.atlas.core.spacing[2]} ${props.theme.atlas.core.spacing[3]}`};
  border-radius: ${(props) =>
    props.theme.isVaultVariant ? '3px' : props.theme.atlas.semantic.radius.lg};
  overflow: hidden;
  background-color: ${(props) =>
    props.theme.isVaultVariant
      ? props.theme.newPalette.neutral.N0
      : props.theme.atlas.semantic.color.surface.default};
  z-index: 5;
  ${(props) =>
    props.width
      ? `width: ${props.width};`
      : `max-width: ${props.maxWidth ?? '200px'};`}
  ${(props) =>
    props.theme.isVaultVariant
      ? props.theme.boxShadows.shadowSmall
      : `box-shadow: ${props.theme.atlas.core.shadow.low};`}
  ${({ theme }) => textStyleCss(theme.atlas.typography.semantic.bodySmall)}
  ${(props) => {
    const padding = (props.extraPaddingForRoot ?? 0) + 5;
    switch (props.variant) {
      case 'up':
        return `margin-top: ${padding}px;`;
      case 'down':
        return `margin-bottom: ${padding}px;`;
      case 'right':
        return `margin-right: ${padding}px;`;
      case 'left':
        return `margin-left: ${padding}px;`;
    }
  }}
  white-space: pre-wrap;
  color: ${(props) => props.theme.atlas.semantic.color.type.default};
  line-break: ${(props) => props.lineBreak || 'normal'};
`;

export const Arrow = styled.div<{ variant: TooltipVariant }>`
  z-index: -1;
  background-color: inherit;
  width: 15px;
  height: 15px;
  visibility: hidden;

  &::before {
    visibility: visible;
    content: '';
    position: absolute;
    width: 15px;
    height: 15px;
    background-color: inherit;
    transform: rotate(45deg);
  }
  ${(props) => {
    switch (props.variant) {
      case 'up':
        return `top: -8px;
        &::before {
          border-radius: 3px 0;
        }`;
      case 'down':
        return `bottom: -8px;
        &::before {
          border-radius: 3px 0;
        }`;
      case 'right':
        return `right: -8px;
        &::before {
          border-radius: 0 3px;
        }`;
      case 'left':
        return `left: -8px;
        &::before {
          border-radius: 0 3px;
        }`;
    }
  }}
`;
export const CenteredText = styled.p`
  text-align: center;
  margin: 0;
`;
export const Background = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  background-color: ${(props) =>
    props.theme.atlas.semantic.color.action.secondary.hoverFill};
  height: 300px;
`;

export const Center = styled.div`
  border-radius: 50%;
  width: 5px;
  height: 5px;
  background-color: transparent;
`;
